export * from '@taqueria/protocol/out/types/Environment';
